import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Badge } from "components/ui/badge";
import * as React from "react";
import { SubnavItem, SubnavPropsOwnProps } from "./subnav-types";

export const NgSubnavCompact: React.FC<SubnavPropsOwnProps> = props => {
    const { selectedSubpage, subpages, navigate, closeSection } = props;
    const expandedItem = subpages.find(item => item.subpage === selectedSubpage);

    const handleBackClick = () => {
        if (closeSection) {
            closeSection();
        }
    };

    const handleListClick = (item: SubnavItem, event: React.MouseEvent) => {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        navigate(item.subpage);
    };

    return (
        <div className="mt-4">
            {expandedItem ? (
                <div className="flex flex-col bg-white">
                    <div className="sticky top-0 flex items-center px-4 py-3 border-b border-gray-200 bg-white z-10">
                        <button
                            onClick={handleBackClick}
                            className="flex items-center text-brand-600 hover:text-brand-700 font-medium">
                            <ChevronLeftIcon className="w-5 h-5 mr-1" />
                            Back
                        </button>
                        <div className="flex-1 text-center">
                            <div className="font-semibold text-gray-900">
                                {expandedItem.linkText}
                            </div>
                        </div>
                        <div className="w-16"></div>
                    </div>

                    <div className="flex-1">{expandedItem.render()}</div>
                </div>
            ) : (
                <ul className="bg-white rounded-lg shadow overflow-hidden">
                    {subpages.map(item => (
                        <li key={item.subpage}>
                            <a
                                className="twoverride text-lg text-gray-700 flex justify-between items-center py-3 px-4 bg-white border-b border-gray-100 hover:bg-gray-50"
                                href="#"
                                onClick={e => handleListClick(item, e)}>
                                <div className="flex items-center">
                                    {item.linkText}
                                    {item.badgeCount !== null &&
                                    item.badgeCount !== undefined ? (
                                        <div className="ml-2">
                                            <Badge
                                                type={item.badgeType || "info"}
                                                value={item.badgeCount}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                                <ChevronRightIcon className="w-5 h-5 text-gray-400" />
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
